import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import FileUploadBlockchain from './../projects_t_engineering/FileUpload/FileUploadBlockchain';
import DocumentModelTopics from "../projects_t_engineering/FileUpload/documentModel/DocumentModelTopics";
import { stylesPgMenuInf } from '../styles';

const ProjectTabComercial = ({ user, project }) => {
  const documentModels = useSelector((state) => state.documentModels.models);


  // Busca o modelo de documento pelo nome
  const modeloComercial = documentModels.find(model => model.nome === 'Modelo Comercial');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Evita erro caso o modelo ainda não tenha sido carregado
  if (!modeloComercial) {
    return <div>Carregando modelo comercial...</div>;

  }

  return (
    <div >
    
      <DocumentModelTopics
        projectId={project.id}
        modeloId={modeloComercial.id}
        telaName="Proposta Comercial"
      />

    </div>
  );
};

export default ProjectTabComercial;
